module.exports = __webpack_public_path__ + "img/corp-features-counseling.fdb1eccf.svg";